import React from 'react';
import { connect } from "react-redux";
import updateProvider from '../../../API/Provider/PutProvider'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import { withRouter } from 'react-router-dom';
import Loader from './../../../Global/loader'
import Select from 'react-select'
import GetProviderCountries from './../../../API/Provider/GetProviderCountries'
import { withNamespaces } from 'react-i18next';
import { AiOutlineFileAdd, AiOutlineSafetyCertificate } from 'react-icons/ai'
import GetCertificate from './../../../API/Provider/GetProviderCertificate'
import forge from 'node-forge'
import fileUpload from './../../../API/Provider/CertUpload'
import history from './../../../history'
import { Button, Row, Col, Form } from "react-bootstrap";

class EditProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            full_name: '',
            email: '',
            phone_number: '',
            countries: [],
            defaultCountries: [],
            pickedCountries: [],        
            selectedFile: '',
            certPass: ''
        }
    
        this.handleChange = this.handleChange.bind(this)
       
        this.handleCountryChange = this.handleCountryChange.bind(this)
      }
    

    componentDidMount = async () => {
        const { t } = this.props
        document.title = t('Edit Provider')

        console.log("EDIT PROVIDER")
        let data = {
            activePage: 1,
            pageSize: 1000,
            search:{
                searchFor: ""
            },
            sortBy: {id: 0},
            sortDirection: 0,
            activeOnly: "Active"
        }
        
        //get countries
        let items = await GetProviderCountries(data)       
        let countryList = []
        
        await items.data.countries
            .map((data, index) =>{
            let oneItem = {value: data.uuid , label: data.country_name, /*isFixed: false */}
            countryList.push(oneItem)
            return null
        })

        let defaultList = []

        if(this.props.oneProvider.countries !== null){
            this.props.oneProvider.countries
            .map((data, index) =>{    
                let oneItem = {value: data.country_uuid , label: data.country_name,/* isFixed: true */}
                defaultList.push(oneItem)
                return null
            })
        }

         // load certificate
         let certificate = await GetCertificate();
         this.props.mapState("MAP_ONE_PROVIDER_CERTIFICATE_DETAILS", certificate.data.data)

        await this.setState({
            countries: countryList,
            defaultCountries: defaultList,
            pickedCountries: defaultList
        })

        await this.setState({
            loading: false            
        })
    }

    handleChange(e){
        this.props.mapState("CHANGE_ONE_PROVIDER_DETAILS", e.target)      
    }

    handleCertChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }

   

    handleCountryChange(e /*value, { action, removedValue }*/){
        /*
        switch (action) {
        case "remove-value":
        case "pop-value":
            if (!removedValue.isFixed) {              
                this.setState({ countries: value})    
            }
            break;
        case "clear":
            value = this.state.pickedCountries.filter(v => v.isFixed);
            this.setState({ countries: value})
            break;
        default:   
            this.setState({ countries: value})    
            break;
        }  
        */     
       
        this.setState({
            defaultCountries: e
        }) 
    }


    updateProvider = async (e) => {
        const { t } = this.props
        e.preventDefault()
        this.setState({ loading: true })
        
        let reponse = await updateProvider(this.props.oneProvider, this.state.defaultCountries) 
        if(reponse.data.status !== 200){
            store.addNotification({
                title: this.props.t('Error!'),
                message: t('An error occurred while updating provider, please try again'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        else{           
            store.addNotification({
                title: "Uspjeh!",
                message: t('Provider update succeeded'),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({
                full_name: '',
                email: '',
                phone_number: '',
                countries: [],
                defaultCountries: [],
                pickedCountries: []
            })  

            this.props.history.push("/providers")
        }
    }

    handlePdv = async () => {
        this.setState({
            in_VAT: !this.state.in_VAT
        })
    } 

    // On file select (from the pop up) 
    onFileChange = async event => { 
        // Update the state 
        await this.setState({ selectedFile: event.target.files[0] }); 
    }; 

     // On file upload (click the upload button) 
    onFileUpload = async () => { 
        const {t} = this.props;
        await this.setState({
            loading: true
        })

        var file = this.state.selectedFile;

        var reader = new FileReader();

        let country = this.props.oneProvider.countries.filter((data) => data.country_name === this.props.oneProvider.country)

        reader.password = this.state.certPass
        reader.oib = this.props.oneProvider.company_legal_id
        reader.clientUuid = this.props.oneProvider.uuid
        reader.selectedFile = this.state.selectedFile
        reader.country_uuid = country[0].country_uuid

        reader.readAsArrayBuffer(file)

        reader.onload = async function () {
        let oib   
            try {
                // get p12 as ASN.1 object
                var p12Asn1 = forge.asn1.fromDer( forge.util.createBuffer( reader.result ) );
                            
                // decrypt p12 using the password returned by getPassword(), the password should be protected and not hard coded
                var p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, this.password  );

                // getting the key slot
                var bags = p12.getBags({friendlyName: p12.safeContents[0].safeBags[0].attributes.friendlyName[0]});   
                var keyBag = bags.friendlyName[0];
        
                let certificateAlias = keyBag.attributes.friendlyName[0]
                oib = bags.friendlyName[1].cert.subject.attributes[1].value.split(" HR")[1]

                if(this.oib !== oib){
                    throw new Error("OIB certifikata je različit od OIB klijenta");
                }
                   
                // Create an object of formData 
                const formData = await new FormData(); 
            
                // Update the formData object 
                await formData.append( 
                    "certificateFile", 
                    this.selectedFile, 
                    this.selectedFile.name 
                ); 

                // Request made to the backend api 
                const certUploaded = await fileUpload(formData,certificateAlias,  this.password)
                
                if( certUploaded.data.status !== 200){
                    store.addNotification({
                        title: t('Error!'),
                        message: certUploaded.data.message,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                        duration: 5000,
                        pauseOnHover: true
                        }
                    });
                    
                }
                else{
                    store.addNotification({
                        title: t('Success!'),
                        message: t('Certificate saved successfully'),
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                        duration: 5000,
                        pauseOnHover: true
                        }
                    });

                    
                }
                
            } catch (error) {
                store.addNotification({
                    title: t('Error!'),
                    message: error.message,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                    duration: 10000,
                    pauseOnHover: true
                    }
                });
            }
            
        };

        this.componentDidMount()
        await this.setState({
            loading: false
        })
        
    }; 

    render(){  
        const { t } = this.props

/*
        const styles = {
            multiValue: (base, state) => {
              return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
            },
            multiValuelabel: (base, state) => {
              return state.data.isFixed
                ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 }
                : base;
            },
            multiValueRemove: (base, state) => {
              return state.data.isFixed ? { ...base, display: 'none' } : base;
            },
          };
          */
          
        return (
                this.state.loading ?
                    <Loader />
                :
                <>
                <Form className="form-container">
                    <Row className="justify-center">
                    <Col sm={12} />
                        <Col sm={12} lg={12} xl={6}>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="full_name" column sm={2} md={4}>{t('Full Name')}<span className="color-red">*</span></Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control
                                        id="full_name"
                                        type="text"
                                        value={this.props.oneProvider.full_name}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>
                      
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="email" column sm={2} md={4}>{t('Email')}<span className="color-red">*</span></Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="email"  
                                        type="text"
                                        value={this.props.oneProvider.email}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>
                       
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="phone_number" className="col-4  col-form-label">{t('Phone Number')}<span className="color-red">*</span></Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="phone_number"  
                                        type="text"
                                        value={this.props.oneProvider.phone_number}
                                        onChange={e => this.handleChange(e)}                                        
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="premisess_label" className="col-4  col-form-label">{t('Premisess Form.Label')}<span className="color-red">*</span></Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="premisess_label"  
                                        type="text"
                                        value={this.props.oneProvider.premisess_label}
                                        onChange={e => this.handleChange(e)}                                        
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="temrinal_label" className="col-4  col-form-label">{t('Terminal Form.Label')}<span className="color-red">*</span></Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="terminal_label"  
                                        type="text"
                                        value={this.props.oneProvider.terminal_label}
                                        onChange={e => this.handleChange(e)}                                        
                                    />
                                </Col>
                            </Form.Group>
                        </Col>

                        <Col sm={12} lg={12} xl={6}>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="OIB" column sm={2} md={4}>{t('OIB')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        maxLength={11}
                                        minLength={11}
                                        id="company_legal_id"  
                                        type="text"
                                        value={this.props.oneProvider.company_legal_id}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="company_address" className="col-4  col-form-label">{t('Address')}<span className="color-red">*</span></Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="company_address"
                                        type="text"
                                        value={this.props.oneProvider.company_address}
                                        onChange={e => this.handleChange(e)}                                        
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="company_place" className="col-4  col-form-label">{t('Place')}<span className="color-red">*</span></Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="company_"
                                        type="text"
                                        value={this.props.oneProvider.company_place}
                                        onChange={e => this.handleChange(e)}                                        
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="company_postal_code" className="col-4  col-form-label">{t('Postal code')}<span className="color-red">*</span></Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="company_"
                                        type="text"
                                        value={this.props.oneProvider.company_postal_code}
                                        onChange={e => this.handleChange(e)}                                        
                                    />
                                </Col>
                            </Form.Group>
                       
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="country" column sm={2} md={4}>{t('Countries')}<span className="color-red">*</span></Form.Label>
                                <Col sm={10} md={8}>
                                    <Select
                                        isMulti={true}
                                        options={this.state.countries} 
                                        onChange={this.handleCountryChange}
                                        isInvalid={this.state.pickedCountries.length === 0} 
                                        value={this.state.defaultCountries}                                        
                                        //styles={styles}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="in_vat_system" column sm={2} md={4}>{t('PDV')}</Form.Label>
                                <Col sm="10" md="8">
                                    <Form.Label className="checbox-form-label p-2" htmlFor="gridCheck2">
                                       <input    
                                            id="in_vat_system"                       
                                            type="checkbox"
                                            checked={this.props.oneProvider.in_vat_system}
                                            onChange={e => this.handleChange(e)}
                                        />                                        
                                        &nbsp;&nbsp; {t('in the VAT system')}
                                    </Form.Label>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                      
                    <Form.Group as={Row} className="mb-3">
                        <Col sm={12} className="button-container text-center">
                            <Button    
                                variant='spremi'
                                onClick={(e) => this.updateProvider(e)}
                                className="btnSpremi"
                            >
                                {t('Save')}
                            </Button>
                        </Col>
                    </Form.Group> 

                <h5 className="mt-5 p-0"> Certifikat </h5>
                <hr/>

                <Row className="certificate-row"> 
                    <Col sm={12} xl={3}>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="PosBr" className="col-6 col-form-label">{t('Fisc. Certificate')}</Form.Label>
                            <Col>
                                <Form.Control className="d-none" type="file" name="uploadfile" id="files" onChange={this.onFileChange}/>
                                <Form.Label className="btnSpremi" htmlFor="files">
                                    <AiOutlineFileAdd size={20}/> 
                                </Form.Label>

                                &nbsp;
                                
                                {this.props.oneProviderCertificate.alias_name ? 
                                    <Form.Label htmlFor="files">
                                        {this.props.oneProviderCertificate.alias_name}
                                        &nbsp;(
                                            {this.props.oneProviderCertificate.length ? this.props.oneProviderCertificate.expiration_date.substring(0,11) : ""}
                                            )
                                    </Form.Label>
                                :
                                    <Form.Label htmlFor="files">{typeof this.state.selectedFile === "string" ? 
                                        "<- " + t('Load Certificate')
                                        : this.state.selectedFile.name}
                                    </Form.Label>
                                }
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="certPass" className="col-6 col-form-label">{t('Password')}</Form.Label>
                            <Col>
                                <Form.Control       
                                    id="certPass"                 
                                    type="text"
                                    value={this.state.certPass}
                                    onChange={e => this.handleCertChange(e)}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3 text-center">
                            <Col >
                                <Button 
                                    variant='spremi'
                                    disabled={typeof this.state.selectedFile === "string" }
                                    className="btnSpremiCert" 
                                    onClick={() => this.onFileUpload(this.state.certPass)}
                                >
                                    <AiOutlineSafetyCertificate size={20} /> &nbsp;
                                        {t('Upload cert.')}
                                </Button>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>

                </Form>
                <div className="form-group mt-5">
                    <div
                        className="btn btn-default mb-2"
                        onClick={() => history.goBack()}
                    > 
                        <BsBackspaceFill size={30} />  
                        <strong> {t('Back')} </strong>
                    </div> 
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        oneProvider: state.provider.oneProvider,
        oneProviderCertificate: state.provider.oneProviderCertificate
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(EditProvider)));